interface Props {
  image: string;
  alt?: string;
}

export default function EmptyState({ image, alt = '' }: Props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '1.5rem 0' }}>
      <img src={image} alt={alt} style={{ maxWidth: '100%', width: 320, height: 'auto' }} />
    </div>
  );
}
